import { h } from '@stencil/core/internal/client';
import { a as heading1 } from './parts.js';

const Header1 = (props) => {
    return h("h1", { class: `header-1 ${props === null || props === void 0 ? void 0 : props.class}`, part: heading1 }, props.text);
};

export { Header1 as H };
